export var OperationType;

(function (OperationType) {
  OperationType["Insert"] = "insert";
  OperationType["Delete"] = "delete";
  OperationType["Replace"] = "replace";
  OperationType["Update"] = "update";
  OperationType["Unknown"] = "unknown";
})(OperationType || (OperationType = {}));

export function operationTypeFromRemote(type) {
  switch (type) {
    case "insert":
      return OperationType.Insert;

    case "delete":
      return OperationType.Delete;

    case "replace":
      return OperationType.Replace;

    case "update":
      return OperationType.Update;

    default:
      return OperationType.Unknown;
  }
}